/**
 * "Pay by" urgency for a held item's last payment date (stored as a UTC
 * midnight calendar date): overdue / due today in red, within 2 days amber.
 */
/** Days from today (local calendar) to a stored YYYY-MM-DD date. */
const daysUntil = (d: Date): number => {
  const today = new Date();
  const t = Date.UTC(today.getFullYear(), today.getMonth(), today.getDate());
  const due = Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
  return Math.round((due - t) / 86_400_000);
};

export const payByTone = (d: Date): { label: string; className: string } => {
  const n = daysUntil(d);
  if (n < 0)
    return { label: `overdue by ${-n}d`, className: 'text-red-700 bg-red-50 ring-red-200' };
  if (n === 0) return { label: 'due today', className: 'text-red-700 bg-red-50 ring-red-200' };
  if (n <= 2)
    return { label: `due in ${n}d`, className: 'text-amber-800 bg-amber-50 ring-amber-200' };
  return { label: `in ${n}d`, className: 'text-zinc-600 bg-zinc-50 ring-zinc-200' };
};
